import { LinhaAPI } from "@/api/linha.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Linha } from "@/models/linha";

const linhaApi = new LinhaAPI();

const findBy = (
  origem: number,
  destino: number,
  recaptcha: string
): AxiosObservable<Linha[]> => {
  return linhaApi.findBy(origem, destino, recaptcha);
};

export default {
  findBy
};
